import { useRef } from 'react'
import { useGSAP } from '@gsap/react'

import { useLenis } from '@/contexts/lenis'

export const useHomeHeroMotion = () => {
  const motionRef = useRef<HTMLDivElement>(null)
  const { lenis } = useLenis()

  /**
   * parallax setup
   */
  useGSAP(
    () => {
      if (!lenis) return
    },
    { scope: motionRef, dependencies: [lenis] }
  )

  return { homeMotionRef: motionRef }
}
